/**
 * variant-sync-fix.js  v6
 *
 * WHAT CHANGED FROM v5 → v6:
 * ──────────────────────────
 * BUG 1 — Class name mismatch (root cause of missing strike styles):
 *   v5 added 'vs-oos' to labels; the CSS file targeted '.variant-unavailable'.
 *   v6 adds BOTH 'vs-oos' and 'variant-unavailable' so either CSS version works.
 *
 * BUG 2 — Theme hides via stylesheet, not inline style/disabled:
 *   v5 MutationObserver only watched inline style + disabled attributes.
 *   Many themes hide OOS options via a CSS class (.hide, .hidden, .is-hidden,
 *   .visually-hidden) added by their own JS, OR via display:none on the <li>
 *   set by a stylesheet rule.  The observer never fired for those cases.
 *   v6 also watches 'class' changes on WRAPPER elements (li, .swatch-wrapper,
 *   .option-wrapper) — NOT on labels/inputs (that was the v4 loop bug) — so
 *   theme hide-class additions on wrappers are caught and reversed.
 *
 * BUG 3 — sweepOOS() didn't force-show wrappers hidden by CSS classes:
 *   v6 also strips .hide/.hidden/.is-hidden/.visually-hidden from the
 *   wrapper <li> / .swatch-wrapper / .option-wrapper.
 *
 * BUG 4 — Initial page-load: theme runs after our 200 ms timeout:
 *   Added a 1 000 ms final sweep (up from 800 ms) and also a 400 ms sweep
 *   to catch themes that finish their init between 200–800 ms.
 *
 * Everything else (guard flag, observer filter, one-tick setTimeout on
 * click, single applyVariant pass) is unchanged from v5.
 *
 * INSTALL:
 *   Upload as  assets/variant-sync-fix.js
 *   In product-template-1.liquid, just before {% endschema %}:
 *     <script src="{{ 'variant-sync-fix.js' | asset_url }}" defer></script>
 *   Add variant-unavailable-states.css (v2) to your theme stylesheet.
 */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    document.querySelectorAll('[data-section-type="product"]').forEach(bootSection);
  }

  /* ─── money helper ────────────────────────────────────────────── */
  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && theme.moneyFormat);
    }
    return '\u20b9' + Math.round(cents / 100);
  }

  /* ══════════════════════════════════════════════════════════════ */
  function bootSection(section) {
    var sid = section.dataset.sectionId;
    if (!sid) return;

    var jsonEl = document.getElementById('ProductJson-' + sid);
    if (!jsonEl) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); }
    catch (e) { console.warn('[vs] bad JSON', e); return; }

    var variants  = product.variants;
    var numOpts   = product.options.length;

    var masterSel = document.getElementById('ProductSelect-' + sid);
    var addBtn    = document.getElementById('AddToCart-' + sid);
    var addBtnTxt = document.getElementById('AddToCartText-' + sid);
    var priceEl   = document.getElementById('ProductPrice-' + sid);
    var cmpEl     = document.getElementById('ComparePrice-' + sid);

    var S        = window.productStrings || {};
    var TXT_ADD  = S.addToCart   || 'Add to cart';
    var TXT_SOLD = S.soldOut     || 'Sold out';
    var TXT_UNV  = S.unavailable || 'Unavailable';

    /* Guard flag — prevents sweepOOS() from re-entering itself */
    var sweeping = false;

    /* ── resolve initial variant ────────────────────────────────── */
    function resolveInitial() {
      var uid = new URLSearchParams(location.search).get('variant');
      if (uid) {
        var v = variants.find(function(x){ return String(x.id) === uid; });
        if (v) return v;
      }
      return variants.find(function(x){ return x.available; }) || variants[0];
    }

    /* ── read currently checked/active option values ─────────────
     *  READ-ONLY — never modifies the DOM.
     */
    function readSelected() {
      var vals = [];
      for (var i = 0; i < numOpts; i++) {
        var r = section.querySelector(
          'input[type="radio"][data-option-index="' + i + '"]:checked,' +
          'input[type="radio"].option' + (i+1) + ':checked'
        );
        if (r) { vals.push(r.value); continue; }

        var sp = section.querySelector(
          '[data-option-index="' + i + '"][data-value].active,' +
          '.option' + (i+1) + '[data-value].active'
        );
        if (sp) { vals.push(sp.dataset.value); continue; }

        var sel = section.querySelector(
          'select#SingleOptionSelector-' + sid + '-' + i + ',' +
          'select[data-option-index="' + i + '"]'
        );
        vals.push(sel ? sel.value : null);
      }
      return vals;
    }

    /* ── find variant matching the current UI selection ─────────── */
    function findVariant(vals) {
      vals = vals || readSelected();
      return variants.find(function(v){
        return vals.every(function(val, i){
          return val === null || v['option' + (i+1)] === val;
        });
      }) || null;
    }

    /* ── apply a variant: sync every surface atomically ─────────── */
    function applyVariant(v, fireChange) {
      if (!v) return;

      if (masterSel) {
        masterSel.value = String(v.id);
        if (fireChange) {
          masterSel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      for (var i = 0; i < numOpts; i++) {
        var optVal = v['option' + (i+1)];

        var oSel = section.querySelector(
          'select#SingleOptionSelector-' + sid + '-' + i + ',' +
          'select[data-option-index="' + i + '"]'
        );
        if (oSel) oSel.value = optVal;

        var disp = section.querySelector('.js-swatch-display--' + (i+1));
        if (disp) disp.textContent = optVal;

        section.querySelectorAll(
          'input[type="radio"][data-option-index="' + i + '"],' +
          'input[type="radio"].option' + (i+1)
        ).forEach(function(radio) {
          radio.checked = (radio.value === optVal);
        });

        section.querySelectorAll(
          '[data-option-index="' + i + '"][data-value],' +
          '.option' + (i+1) + '[data-value]'
        ).forEach(function(el) {
          var active = (el.dataset.value === optVal);
          el.classList.toggle('active', active);
          el.setAttribute('aria-pressed', String(active));
        });
      }

      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.classList.toggle('btn--sold-out', !v.available);
      }
      if (addBtnTxt) {
        addBtnTxt.textContent = v.available ? TXT_ADD : TXT_SOLD;
      }

      if (priceEl) {
        priceEl.innerHTML = formatMoney(v.price);
        priceEl.setAttribute('content', (v.price / 100).toFixed(2));
      }
      if (cmpEl) {
        var showCmp = v.compare_at_price && v.compare_at_price > v.price;
        if (showCmp) cmpEl.innerHTML = formatMoney(v.compare_at_price);
        var li = cmpEl.closest('li');
        if (li) li.style.display = showCmp ? '' : 'none';
      }

      var wl = section.querySelector('.js-contact-soldout');
      if (wl) wl.classList.toggle('hide', !!v.available);

      if (history.replaceState) {
        try {
          var u = new URL(location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        } catch(e) {}
      }

      section.dispatchEvent(new CustomEvent('variantChange', {
        bubbles: true, detail: { variant: v }
      }));
    }

    /* ── sweepOOS ────────────────────────────────────────────────────
     *
     * Marks OOS labels AND restores any element the theme has hidden.
     *
     * CLASS NAMES APPLIED (v6 fix):
     *   Adds both 'vs-oos' AND 'variant-unavailable' so that this JS
     *   works with CSS files that target either class name.
     *
     * VISIBILITY RESTORATION (v6 fix):
     *   In addition to inline style/disabled (v5), this also strips
     *   CSS hide-classes (.hide, .hidden, .is-hidden, .visually-hidden)
     *   from the option element, its label, AND its wrapper <li>.
     *
     * GUARD:
     *   `sweeping` flag prevents re-entrant calls.
     *   Class changes on labels and inputs do NOT trigger the observer
     *   (the observer filters to wrapper elements for class changes).
     */
    function sweepOOS() {
      if (sweeping) return;
      sweeping = true;

      /* Classes the theme uses to visually hide elements */
      var HIDE_CLASSES = ['hide', 'hidden', 'is-hidden', 'visually-hidden', 'invisible'];

      try {
        var currentVals = readSelected();

        for (var i = 0; i < numOpts; i++) {

          /* ── radio inputs ──────────────────────────────────────── */
          section.querySelectorAll(
            'input[type="radio"][data-option-index="' + i + '"],' +
            'input[type="radio"].option' + (i+1)
          ).forEach(function(radio) {
            var testVals = currentVals.slice();
            testVals[i] = radio.value;

            var avail = variants.some(function(v){
              return v.available && testVals.every(function(val, k){
                return val === null || v['option'+(k+1)] === val;
              });
            });

            var lbl = radio.id
              ? section.querySelector('label[for="' + radio.id + '"]')
              : radio.nextElementSibling;

            /* ── Apply / remove OOS class on the label ── */
            if (lbl) {
              if (!avail) {
                lbl.classList.add('vs-oos', 'variant-unavailable');
              } else {
                lbl.classList.remove('vs-oos', 'variant-unavailable');
              }
            }

            /* ── Restore visibility: input ── */
            if (radio.hasAttribute('disabled')) radio.removeAttribute('disabled');
            if (radio.style.display === 'none')        radio.style.display = '';
            if (radio.style.visibility === 'hidden')   radio.style.visibility = '';
            HIDE_CLASSES.forEach(function(c){ radio.classList.remove(c); });

            /* ── Restore visibility: label ── */
            if (lbl) {
              if (lbl.style.display === 'none')        lbl.style.display = '';
              if (lbl.style.visibility === 'hidden')   lbl.style.visibility = '';
              HIDE_CLASSES.forEach(function(c){ lbl.classList.remove(c); });
            }

            /* ── Restore visibility: wrapper li / .swatch-wrapper / .option-wrapper ── */
            var wrap = radio.closest('li, .swatch-wrapper, .option-wrapper');
            if (wrap) {
              if (wrap.style.display === 'none')       wrap.style.display = '';
              if (wrap.style.visibility === 'hidden')  wrap.style.visibility = '';
              HIDE_CLASSES.forEach(function(c){ wrap.classList.remove(c); });
            }
          });

          /* ── span / button swatches (non-radio themes) ─────────── */
          section.querySelectorAll(
            '[data-option-index="' + i + '"][data-value],' +
            '.option' + (i+1) + '[data-value]'
          ).forEach(function(el) {
            var testVals = currentVals.slice();
            testVals[i] = el.dataset.value;
            var avail = variants.some(function(v){
              return v.available && testVals.every(function(val, k){
                return val === null || v['option'+(k+1)] === val;
              });
            });

            if (!avail) {
              el.classList.add('vs-oos', 'variant-unavailable');
            } else {
              el.classList.remove('vs-oos', 'variant-unavailable');
            }

            /* Restore visibility */
            if (el.style.display === 'none')       el.style.display = '';
            if (el.style.visibility === 'hidden')  el.style.visibility = '';
            HIDE_CLASSES.forEach(function(c){ el.classList.remove(c); });

            /* Wrapper */
            var wrap = el.closest('li, .swatch-wrapper, .option-wrapper');
            if (wrap) {
              if (wrap.style.display === 'none')      wrap.style.display = '';
              if (wrap.style.visibility === 'hidden') wrap.style.visibility = '';
              HIDE_CLASSES.forEach(function(c){ wrap.classList.remove(c); });
            }
          });
        }
      } finally {
        sweeping = false;
      }
    }

    /* ── interaction handler ─────────────────────────────────────── */
    function onInteract(e) {
      var t = e.target;

      var isRadio = !!(t.matches && t.matches(
        'input[type="radio"][data-option-index],' +
        'input[type="radio"].option1,' +
        'input[type="radio"].option2,' +
        'input[type="radio"].option3'
      ));

      var isSwatch = !!(t.closest && (
        t.closest('[data-option-index][data-value]') ||
        t.closest('.swatch') ||
        t.closest('.option-btn')
      ));

      var isOptSel = !!(e.type === 'change' && t.matches && t.matches(
        'select#SingleOptionSelector-' + sid + '-0,' +
        'select#SingleOptionSelector-' + sid + '-1,' +
        'select#SingleOptionSelector-' + sid + '-2,' +
        'select[data-option-index]'
      ));

      if (!isRadio && !isSwatch && !isOptSel) return;

      setTimeout(function() {
        var v = findVariant();
        if (v) {
          applyVariant(v, true);
        } else {
          if (addBtn)    addBtn.disabled = true;
          if (addBtnTxt) addBtnTxt.textContent = TXT_UNV;
        }
        sweepOOS();
      }, 0);
    }

    section.addEventListener('click',  onInteract);
    section.addEventListener('change', onInteract);

    /* ── MutationObserver ────────────────────────────────────────────
     *
     * v6 change: also watches 'class' attribute on WRAPPER elements
     * (li, .swatch-wrapper, .option-wrapper) — NOT on labels or inputs.
     * This lets us catch themes that add .hide/.hidden to the wrapper
     * via their own JS after an AJAX variant lookup.
     *
     * Watching 'class' on labels/inputs would recreate the v4 loop bug
     * because our own sweepOOS() modifies label classes.  Wrappers are
     * safe because sweepOOS() only removes classes from them — it never
     * adds any — so the observer will not see our own changes as relevant.
     */
    var moTimer;
    new MutationObserver(function(mutations) {
      if (sweeping) return;

      var relevant = mutations.some(function(m) {
        if (m.type !== 'attributes') return false;
        var el = m.target;

        /* disabled / style on radio inputs (unchanged from v5) */
        if (el.tagName === 'INPUT' && el.type === 'radio') {
          return m.attributeName === 'disabled' || m.attributeName === 'style';
        }

        /*
         * v6: class changes on wrapper elements only.
         * Check that the element is a <li> or has a wrapper class.
         * This avoids reacting to label class changes (which would loop).
         */
        if (m.attributeName === 'class') {
          var isWrapper = (
            el.tagName === 'LI' ||
            el.classList.contains('swatch-wrapper') ||
            el.classList.contains('option-wrapper')
          );
          return isWrapper;
        }

        return false;
      });

      if (!relevant) return;

      clearTimeout(moTimer);
      moTimer = setTimeout(sweepOOS, 80);
    }).observe(section, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'style', 'class']
    });

    /* ── page load ───────────────────────────────────────────────── */
    var initial = resolveInitial();
    applyVariant(initial, false);
    sweepOOS();

    /* Catch themes that finish init between 0–200 ms */
    setTimeout(function() {
      sweepOOS();
      if (masterSel) {
        masterSel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 200);

    /* Catch themes that finish init between 200–400 ms */
    setTimeout(sweepOOS, 400);

    /* Final catch-all for slow theme scripts */
    setTimeout(sweepOOS, 1000);
  }

})();